import z from 'zod';
import { PackageSchema } from './Package';

export const PackageListResultSchema = z.object({
    data: z.array(PackageSchema),
    total: z.number(),
});

export type PackageListResult = z.infer<typeof PackageListResultSchema>;
